<form #newA="ngForm" name="newA" (ngSubmit)="onSubmit(newA)" id="newA" class="course-form mb-0">

  <header class="cf-head">
    <span class="cf-head__icon"><i class="fas fa-clipboard-list" aria-hidden="true"></i></span>
    <div class="cf-head__text">
      <h1 class="cf-head__title">{{isEdit ? 'Edit Assessment' : 'Create New Assessment'}}</h1>
      <p class="cf-head__sub">Set the questions type, timing and weighting</p>
    </div>
    <div class="cf-head__actions">
      <button type="button" class="btn btn--warning m-0" *ngIf="isEdit" routerLink="/user/assessmentdetails"
        [queryParams]="{classid : this.classID, batchid: this.assessmentItem.batchID,aid:this.assessmentItem.id}">Cancel</button>
      <button type="button" class="btn btn--warning m-0" routerLink="/user/assessmentconsole"
        [queryParams]="{classid : this.classID, batchid: this.assessmentItem.batchID}" *ngIf="!isEdit">Cancel</button>
      <button type="submit" class="btn m-0" [disabled]="!newA.valid || freezePage_formSubmissionInProgress">
        <i class="fas fa-save" aria-hidden="true"></i> Save Assessment
      </button>
    </div>
  </header>

  <section class="cf-card">
    <h2 class="cf-card__title"><i class="far fa-file-alt" aria-hidden="true"></i> Basic Information</h2>
  <div class="fieldset fieldset--lg">
    <label for="name" class="legend">Name <span class="requiredfield">*</span></label>
    <input class="text-field" required type="text" id="name" name="name" [(ngModel)]="this.assessmentItem.name" #name
      autofocus>
    <button type="button" data-toggle="dropdown" aria-expanded="false" title="Assessment name"
      class="position-absolute right-0 top-0 bottom-0 m-auto d-flex align-items-center pr-3 bg-transparent border-0 text-body"><i
        class="fa fa-info-circle"></i></button>
    <div class="info-popup dropdown-menu p-2">
      <p class="form-info-p">The name students see in the lesson's assessment list.</p>
    </div>
  </div>
  <!-- Was a flex row with its own `fieldset--lg m-auto`, which centred the pair at a width
       unrelated to the card and left it out of line with the fields above and below. -->
  <div class="cf-grid">
    <div class="fieldset fieldset--lg" *ngIf="!isEdit">
      <label for="adm" class="legend">Assessment Type <span class="requiredfield">*</span></label>
      <select class="text-field" ngModel name="deliveryMode" id="adm" #deliveryMode required>
        <option value="{{AssessmentDeliveryMode_UntimedAssessment}}">Untimed Assessment</option>
        <option value="{{AssessmentDeliveryMode_TimedAssessment}}">Timed Assessment</option>
      </select>
      <button type="button" data-toggle="dropdown" aria-expanded="false" title="Assessment type"
        class="position-absolute right-0 top-0 bottom-0 m-auto d-flex align-items-center pr-3 bg-transparent border-0 text-body"><i
          class="fa fa-info-circle"></i></button>
      <div class="info-popup dropdown-menu p-2">
        <p class="form-info-p">With Timed, a clock starts when the student opens the assessment, and their work goes in when it runs out. Untimed lets them work whenever they like between the start and due times. It cannot be changed once the assessment is saved.</p>
      </div>
    </div>
    <div class="fieldset fieldset--lg" id="durationHolder"
      *ngIf="assessmentItem.timedType!='UntimedAssessment'">
      <label for="duration" class="legend">Duration (Minutes)</label>
      <input class="text-field" type="number" id="duration" name="duration" [(ngModel)]="this.assessmentItem.duration"
        #duration>
      <button type="button" data-toggle="dropdown" aria-expanded="false" title="Duration"
        class="position-absolute right-4 top-0 bottom-0 m-auto d-flex align-items-center pr-3 bg-transparent border-0 text-body"><i
          class="fa fa-info-circle"></i></button>
      <div class="info-popup dropdown-menu p-2">
        <p class="form-info-p">How long a student gets once they open the assessment. At least 1 minute, and it has to fit between the start and due times.</p>
      </div>
    </div>
  </div>
  <div class="fieldset fieldset--lg" *ngIf="!isEdit">
    <label for="assessmentType" class="legend">Question Type <span class="requiredfield">*</span></label>
    <select class="text-field" ngModel name="assessmentType" id="assessmentType" #assessmentType [(ngModel)]="this.assessmentItem.questionType" required>
      <option value="{{QuestionType_MultipleChoice}}">Multiple Choice</option>
      <option value="{{QuestionType_LongText}}">Essay/Comprehension</option>
      <option value="{{QuestionType_FileUpload}}">File Upload</option>
    </select>
    <button type="button" data-toggle="dropdown" aria-expanded="false" title="Question type"
      class="position-absolute right-0 top-0 bottom-0 m-auto d-flex align-items-center pr-3 bg-transparent border-0 text-body"><i
        class="fa fa-info-circle"></i></button>
    <div class="info-popup dropdown-menu p-2">
      <p class="form-info-p">Multiple choice is marked automatically the moment it is submitted. Essay and file upload are marked by a tutor. It cannot be changed once the assessment is saved.</p>
    </div>
  </div>
  <div class="fieldset fieldset--lg" *ngIf="this.assessmentItem.questionType === QuestionType_LongText">
    <label for="essayTextLimit" class="legend">Maximum Word Count</label>
    <input class="text-field" type="number" id="essayTextLimit" name="essayTextLimit" [(ngModel)]="this.assessmentItem.essayTextLimit" #essayTextLimit
    >
    <button type="button" data-toggle="dropdown" aria-expanded="false" title="Maximum word count"
      class="position-absolute right-4 top-0 bottom-0 m-auto d-flex align-items-center pr-3 bg-transparent border-0 text-body"><i
        class="fa fa-info-circle"></i></button>
    <div class="info-popup dropdown-menu p-2">
      <p class="form-info-p">Puts a word counter on each answer and flags the question once a student goes over. It does not stop them submitting. 0 means no limit.</p>
    </div>
  </div>
  </section>

  <section class="cf-card">
    <h2 class="cf-card__title"><i class="far fa-calendar-alt" aria-hidden="true"></i> Availability</h2>
    <div class="cf-grid">
  <div class="fieldset fieldset--lg">
    <label for="startt" class="legend">Start Time <span class="requiredfield">*</span></label>
    <input [owlDateTime]="rawStartTime" class="text-field" id="startt" name="startt"
      [(ngModel)]="this.assessmentItem.rawStartTime" #startt [disabled]="isMultipleBatch">
    <button [owlDateTimeTrigger]="rawStartTime" type="button" [disabled]="isMultipleBatch"
      class="owlDateTimeTrigger position-absolute right-0 top-0 m-auto d-flex align-items-center px-3 bg-transparent border-0 text-body"
      [ngClass]="isMultipleBatch? 'bottom-0-t':'bottom-0'" title="Calendar"><i class="fa fa-calendar"></i></button>
    <owl-date-time #rawStartTime></owl-date-time>
    <button type="button" data-toggle="dropdown" aria-expanded="false" title="Start time"
      class="position-absolute right-4 top-0 bottom-0 m-auto d-flex align-items-center pr-3 bg-transparent border-0 text-body"><i
        class="fa fa-info-circle"></i></button>
    <div class="info-popup dropdown-menu p-2">
      <p class="form-info-p">The first moment a student can open the assessment. It cannot be in the past.</p>
    </div>

    <p class="form-info-p" *ngIf="isMultipleBatch">Please update the assessment start and end times from the currently
      running batches after save. <a [routerLink]="['/user/modulebatches']" [queryParams]="{moduleID: moduleId}">View Batches</a>
    </p>
  </div>
  <div class="fieldset fieldset--lg">
    <label for="endt" class="legend">Due Time <span class="requiredfield">*</span></label>
    <input [owlDateTime]="rawEndTime" class="text-field" id="endt" name="endt"
      [(ngModel)]="this.assessmentItem.rawEndTime" #endt [disabled]="isMultipleBatch">
    <button [owlDateTimeTrigger]="rawEndTime" type="button" [disabled]="isMultipleBatch"
      class="owlDateTimeTrigger position-absolute right-0 top-0  m-auto d-flex align-items-center px-3 bg-transparent border-0 text-body"
      [ngClass]="isMultipleBatch? 'bottom-0-t':'bottom-0'" title="Calendar"><i class="fa fa-calendar"></i></button>
    <owl-date-time #rawEndTime></owl-date-time>
    <button type="button" data-toggle="dropdown" aria-expanded="false" title="Due time"
      class="position-absolute right-4 top-0 bottom-0 m-auto d-flex align-items-center pr-3 bg-transparent border-0 text-body"><i
        class="fa fa-info-circle"></i></button>
    <div class="info-popup dropdown-menu p-2">
      <p class="form-info-p">The last moment a student can submit. It has to be after the start time.</p>
    </div>

    <p class="form-info-p" *ngIf="isMultipleBatch">Please update the assessment start and end times from the currently
      running batches after save. <a [routerLink]="['/user/modulebatches']" [queryParams]="{moduleID: moduleId}">View Batches</a>
    </p>
  </div>
    </div>
  </section>

  <section class="cf-card">
    <h2 class="cf-card__title"><i class="fas fa-sliders-h" aria-hidden="true"></i> Scoring &amp; Behaviour</h2>
    <div class="cf-grid cf-grid--top">
  <div class="fieldset fieldset--lg" *ngIf="!assessmentItem.quizAssessment">
    <label for="optional" class="legend">Optional</label>
    <!-- These were plain `value` attributes, so the option values were the strings "true"/"false"
         while the model holds a boolean. Nothing ever matched and the control rendered blank on a
         new assessment. [ngValue] binds the real boolean. -->
    <select class="text-field" [(ngModel)]="this.assessmentItem.optional" (ngModelChange)="onOptionalChange($event)" #optional name="optional" id="optional">
      <option [ngValue]="true">
        Yes
      </option>
      <option [ngValue]="false">
        No
      </option>
    </select>
    <button type="button" data-toggle="dropdown" aria-expanded="false" title="Optional"
      class="position-absolute right-0 top-0 bottom-0 m-auto d-flex align-items-center pr-3 bg-transparent border-0 text-body"><i
        class="fa fa-info-circle"></i></button>
    <div class="info-popup dropdown-menu p-2">
      <p class="form-info-p">Yes leaves the assessment out of the course pass score, and a student can finish the lesson without submitting it.</p>
    </div>
  </div>
  <div class="fieldset fieldset--lg" *ngIf="countsTowardsScore">
    <label for="weight" class="legend">Weight (%) <span class="requiredfield">*</span></label>
    <input class="text-field" required type="number" id="weight" max="100" name="weight"
      [(ngModel)]="this.assessmentItem.weight" #weight>
    <button type="button" data-toggle="dropdown" aria-expanded="false" title="Weight"
      class="position-absolute right-0 top-0 bottom-0 m-auto d-flex align-items-center pr-4 mr-3 bg-transparent border-0 text-body"><i
        class="fa fa-info-circle"></i></button>
    <div class="info-popup dropdown-menu p-2">
      <p class="form-info-p">How much this assessment counts towards the course score. The student's % on it is multiplied by this weight, then averaged with the other assessments' weights. Weights don't need to add up to 100. Optional assessments and lesson quizzes don't count.</p>
    </div>
  </div>
  <div class="scoring-field">
  <div class="fieldset fieldset--lg">
    <label for="quizAssessment" class="legend">Lesson Quiz</label>
    <select class="text-field" [(ngModel)]="this.assessmentItem.quizAssessment" (ngModelChange)="onQuizChange($event)" #quizAssessment name="quizAssessment" id="quizAssessment">
      <option [ngValue]="false">
        No
      </option>
      <option [ngValue]="true" [disabled]="lessonHasQuiz && !assessmentItem.quizAssessment">
        Yes{{lessonHasQuiz && !assessmentItem.quizAssessment ? ' (this lesson already has a quiz)' : ''}}
      </option>
    </select>
    <button type="button" data-toggle="dropdown" aria-expanded="false" title="Lesson quiz"
      class="position-absolute right-0 top-0 bottom-0 m-auto d-flex align-items-center pr-3 bg-transparent border-0 text-body"><i
        class="fa fa-info-circle"></i></button>
    <div class="info-popup dropdown-menu p-2">
      <p class="form-info-p">A quiz sits inside the lesson itself and has to be multiple choice. A lesson can only have one, and it does not count towards the course pass score.</p>
    </div>
  </div>
    <p class="form-info-p scoring-field__hint" *ngIf="!lessonHasQuiz || assessmentItem.quizAssessment">Assessment will be taken before proceeding to next lesson</p>
    <p class="form-info-p scoring-field__hint" *ngIf="lessonHasQuiz && !assessmentItem.quizAssessment">This lesson already has a quiz. A lesson can only have one.</p>
  </div>
    </div>
    <p class="scoring-quiz-note" *ngIf="assessmentItem.quizAssessment">
      <i class="fas fa-info-circle" aria-hidden="true"></i>
      Lesson quizzes don't count towards the course score, so Optional and Weight don't apply. They are saved as No and 0.
    </p>
    <p class="scoring-quiz-note" *ngIf="!assessmentItem.quizAssessment && assessmentItem.optional">
      <i class="fas fa-info-circle" aria-hidden="true"></i>
      Optional assessments don't count towards the course score, so Weight doesn't apply and is saved as 0.
      Students can finish the lesson without submitting it.
    </p>
    <app-scoring-explainer class="d-block mt-4" context="assessment" [classId]="classID" [assessmentId]="assessmentID"
      [weight]="assessmentItem.weight" [optional]="assessmentItem.optional" [quiz]="assessmentItem.quizAssessment"
      *ngIf="countsTowardsScore"></app-scoring-explainer>
  </section>

  <div class="cf-footer">
    <span class="cf-footer__hint">
      <i class="fas fa-clipboard-list" aria-hidden="true"></i>
      <span>{{isEdit ? 'Update this assessment\'s setup. Its questions are managed separately.' : 'After saving, you will be taken to the assessment so you can add its questions.'}}</span>
    </span>
    <span class="cf-footer__actions">
      <button type="button" class="btn btn--warning m-0" *ngIf="isEdit" routerLink="/user/assessmentdetails"
        [queryParams]="{classid : this.classID, batchid: this.assessmentItem.batchID,aid:this.assessmentItem.id}">Cancel</button>
      <button type="button" class="btn btn--warning m-0" routerLink="/user/assessmentconsole"
        [queryParams]="{classid : this.classID, batchid: this.assessmentItem.batchID}" *ngIf="!isEdit">Cancel</button>
      <!-- The two Save buttons here were identical apart from their *ngIf, and both carried
           id="crt-new-asmt" — a duplicate id in the document, which a jQuery handler binds to. -->
      <button type="submit" class="btn m-0" [disabled]="!newA.valid || freezePage_formSubmissionInProgress"
        id="crt-new-asmt">Save</button>
    </span>
  </div>
</form>
